(function(){
  function pad(n){return n<10?'0'+n:''+n}
  function endFor(el){
    var mode=el.getAttribute('data-mode')||'daily',now=new Date();
    if(mode==='fixed'){var t=Date.parse(el.getAttribute('data-end')||'');if(!isNaN(t))return t;}
    var d=new Date(now);d.setHours(23,59,59,999);return d.getTime();
  }
  function init(el){
    var end=endFor(el);
    var h=el.querySelector('[data-h]'),m=el.querySelector('[data-m]'),s=el.querySelector('[data-s]'),dd=el.querySelector('[data-d]');
    function tick(){
      var diff=Math.max(0,end-Date.now());
      var days=Math.floor(diff/864e5),hrs=Math.floor(diff%864e5/36e5),min=Math.floor(diff%36e5/6e4),sec=Math.floor(diff%6e4/1e3);
      if(dd){dd.textContent=pad(days)}else{hrs+=days*24}
      if(h)h.textContent=pad(hrs);if(m)m.textContent=pad(min);if(s)s.textContent=pad(sec);
      if(diff===0&&el.getAttribute('data-mode')!=='fixed'){end=endFor(el)}
    }
    tick();setInterval(tick,1000);
  }
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.querySelectorAll('[data-pcd]').forEach(init);
    var items=document.querySelectorAll('.pm-reveal');
    if(!('IntersectionObserver' in window)){items.forEach(function(i){i.classList.add('is-in')});return}
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.12});
    items.forEach(function(i,idx){i.style.transitionDelay=(idx%4)*80+'ms';io.observe(i)});
  });
})();

/* ===== v2: delivery timeline, progress bar, ripple ===== */
(function(root){
  function addWork(d,n,skip){var x=new Date(d.getTime()),c=0;while(c<n){x.setDate(x.getDate()+1);if(!(skip&&x.getDay()===0))c++}return x}
  function sameDay(a,b){return a.getFullYear()===b.getFullYear()&&a.getMonth()===b.getMonth()&&a.getDate()===b.getDate()}
  function compute(now,o){
    var sunday=o.skip&&now.getDay()===0;
    var before=!sunday&&now.getHours()<o.cutoff;
    var dispatch=before?new Date(now.getTime()):addWork(now,1,o.skip);
    var cutAt=new Date(now.getFullYear(),now.getMonth(),now.getDate(),o.cutoff,0,0,0);
    return {before:before,dispatch:dispatch,dmin:addWork(dispatch,o.min,o.skip),dmax:addWork(dispatch,o.max,o.skip),cutMs:cutAt-now,sunday:sunday};
  }
  root.__pmDelivery={compute:compute,addWork:addWork,sameDay:sameDay};
  if(typeof document==='undefined')return;
  function fmt(d){try{return d.toLocaleDateString('en-GB',{weekday:'short',day:'numeric',month:'short'})}catch(e){return d.toDateString().slice(0,10)}}
  function rel(d,now){if(sameDay(d,now))return 'Today';var t=new Date(now.getTime());t.setDate(t.getDate()+1);return sameDay(d,t)?'Tomorrow':fmt(d)}
  function pad(n){return n<10?'0'+n:''+n}
  function initDL(el){
    var o={min:+el.dataset.min||2,max:Math.max(+el.dataset.max||4,+el.dataset.min||2),cutoff:+el.dataset.cutoff||18,skip:el.dataset.skipsun!=='false'};
    var cut=el.querySelector('[data-cut]');
    function q(k){return el.querySelector('[data-d="'+k+'"]')}
    function render(){
      var now=new Date(),r=compute(now,o);
      q('dispatch').textContent=rel(r.dispatch,now);
      q('deliver').textContent=o.min===o.max?fmt(r.dmin):fmt(r.dmin)+' - '+fmt(r.dmax);
      if(r.before){var s=Math.max(0,Math.floor(r.cutMs/1000));
        cut.innerHTML='&#9200; Order in the next <b>'+pad(Math.floor(s/3600))+'h '+pad(Math.floor(s%3600/60))+'m '+pad(s%60)+'s</b> for same-day dispatch'}
      else{cut.innerHTML='&#128230; Order now &mdash; your parcel dispatches <b>'+rel(r.dispatch,now).toLowerCase()+'</b>'}
    }
    render();setInterval(render,1000);
  }
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    document.querySelectorAll('[data-pm-dl]').forEach(initDL);
    var bar=document.createElement('div');bar.id='pm-prog';document.body.appendChild(bar);
    var tk=false;window.addEventListener('scroll',function(){if(tk)return;tk=true;requestAnimationFrame(function(){
      var h=document.documentElement.scrollHeight-window.innerHeight;bar.style.width=(h>0?Math.min(100,window.scrollY/h*100):0)+'%';tk=false})},{passive:true});
    document.addEventListener('click',function(e){
      var b=e.target.closest&&e.target.closest('.pm-btn,.product-form__cart-submit,.pm-fl-btn');if(!b)return;
      var r=b.getBoundingClientRect(),d=Math.max(r.width,r.height),s=document.createElement('span');
      s.className='pm-ripple';s.style.cssText='width:'+d+'px;height:'+d+'px;left:'+(e.clientX-r.left-d/2)+'px;top:'+(e.clientY-r.top-d/2)+'px';
      if(getComputedStyle(b).position==='static')b.style.position='relative';b.style.overflow='hidden';b.appendChild(s);setTimeout(function(){s.remove()},650)});
  });
})(typeof window!=='undefined'?window:globalThis);
